(function () {
  var ITEM_TARGET_10 = 1;
  var ITEM_TARGET_15 = 3;
  var SPEND_TARGET = 100;
  var SHIPPING_TARGET = 50;
  var DISCOUNT_10 = 0.1;
  var DISCOUNT_15 = 0.15;
  var DISCOUNT_20 = 0.2;
  var TICK_FAST_MS = 400;
  var TICK_IDLE_MS = 2000;
  var CART_POLL_MS = 4000;
  var lastCartTotals = null;
  var cartRequestInFlight = false;
  var lastPaintKey = '';
  var idleTicks = 0;
  var tickTimer = null;
  var cartTimer = null;
  var tickMs = 0;

  var STATIC_CSS = [
    '.tb-price-was{text-decoration:line-through;color:#9a948b;margin-right:.35em;font-weight:400;}',
    '.tb-price-now{color:#2a7a6a;font-weight:600;}',
    '.as-bundle-cart-dailog .tb-tier-bars{display:flex!important;flex-direction:column;gap:10px;padding:4px 0 8px;}',
    '.as-bundle-cart-dailog .tb-tier-label{font-size:12px!important;color:#4a3f35!important;margin-bottom:4px;display:flex;justify-content:space-between;gap:8px;}',
    '.as-bundle-cart-dailog .tb-tier-track{height:8px!important;width:100%!important;background:#e5ddd1!important;border-radius:999px!important;overflow:hidden!important;}',
    '.as-bundle-cart-dailog .tb-fill{display:block!important;height:100%!important;width:0;border-radius:999px!important;background:#4f7a6b;transition:width .3s ease;}',
    '.tb-fill.tb-complete{background:#2f5c4a;}',
    '#AppstleBabMain .tb-tier-bars{flex-wrap:wrap;}',
    '#AppstleBabMain .tb-tier{min-width:140px;}',
    '.as-bundle-cart-dailog .as-sub-total .tb-price-was,.as-bundle-cart-dailog .as-sub-total .tb-price-now{font-size:inherit;}'
  ].join('');

  function parseCurrency(text) {
    return parseFloat(String(text || '').replace(/[^0-9.]/g, '')) || 0;
  }

  function centsToDollars(cents) {
    return (Number(cents) || 0) / 100;
  }

  function formatMoney(amount) {
    return '$' + Number(amount || 0).toFixed(2);
  }

  function ensureStaticStyles() {
    if (document.getElementById('tb-bab-tier-static-style')) return;
    var el = document.createElement('style');
    el.id = 'tb-bab-tier-static-style';
    el.textContent = STATIC_CSS;
    document.head.appendChild(el);
  }

  function buildWrapper() {
    var wrapper = document.createElement('div');
    wrapper.className = 'tb-tier-bars';
    wrapper.innerHTML =
      '<div class="tb-tier">' +
        '<div class="tb-tier-label"><span>Buy 1, get 10% off</span><span class="tb-tier-count-10">0 / 1 items</span></div>' +
        '<div class="tb-tier-track"><span class="tb-fill tb-fill-10"></span></div>' +
      '</div>' +
      '<div class="tb-tier">' +
        '<div class="tb-tier-label"><span>Buy 3, get 15% off</span><span class="tb-tier-count-15">0 / 3 items</span></div>' +
        '<div class="tb-tier-track"><span class="tb-fill tb-fill-15"></span></div>' +
      '</div>' +
      '<div class="tb-tier">' +
        '<div class="tb-tier-label"><span>Free shipping at $50</span><span class="tb-tier-count-ship">$0.00 / $50.00</span></div>' +
        '<div class="tb-tier-track"><span class="tb-fill tb-fill-ship"></span></div>' +
      '</div>' +
      '<div class="tb-tier">' +
        '<div class="tb-tier-label"><span>Spend $100, get 20% off</span><span class="tb-tier-count-20">$0.00 / $100.00</span></div>' +
        '<div class="tb-tier-track"><span class="tb-fill tb-fill-20"></span></div>' +
      '</div>';
    return wrapper;
  }

  function moveSubtitle() {
    var titleWrap = document.querySelector('#AppstleBabMain .as-bab-header .as-min-w-0');
    var subtitleWrap = document.querySelector('#AppstleBabMain .as-choseProduct-title-wrapper');
    var subtitle = subtitleWrap ? subtitleWrap.querySelector('h2.as-single-product-title') : null;
    if (!titleWrap || !subtitle) return;
    if (subtitle.classList.contains('tb-subtitle-moved')) return;
    subtitle.classList.add('tb-subtitle-moved');
    titleWrap.appendChild(subtitle);
    if (subtitleWrap) subtitleWrap.classList.add('tb-subtitle-wrapper-empty');
  }

  function getCardQuantity(card) {
    var qtyEl = card.querySelector('[name="custom-input-number"]');
    if (qtyEl) {
      var typed = parseInt((qtyEl.textContent || '').trim(), 10);
      if (!isNaN(typed)) return typed;
    }
    var qtyWrap = card.querySelector('[class*="quantity-"]');
    var match = qtyWrap && qtyWrap.className.match(/quantity-(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function captureOriginal(el) {
    if (!el) return 0;
    var was = el.querySelector('.tb-price-was');
    if (was) {
      var original = parseCurrency(was.textContent);
      el.dataset.tbOriginal = String(original);
      return original;
    }
    if (!el.querySelector('.tb-price-now')) {
      var value = parseCurrency(el.textContent);
      el.dataset.tbOriginal = String(value);
      return value;
    }
    return parseFloat(el.dataset.tbOriginal) || 0;
  }

  function getDiscountRate(itemCount, preDiscountSpend) {
    if (preDiscountSpend >= SPEND_TARGET) return DISCOUNT_20;
    if (itemCount >= ITEM_TARGET_15) return DISCOUNT_15;
    if (itemCount >= ITEM_TARGET_10) return DISCOUNT_10;
    return 0;
  }

  function discountedAmount(original, rate) {
    return Math.round(original * (1 - rate) * 100) / 100;
  }

  function paintPrice(el, original, rate) {
    if (!el) return;
    if (rate <= 0) {
      el.innerHTML = formatMoney(original);
      return;
    }
    el.innerHTML =
      '<span class="tb-price-was">' + formatMoney(original) + '</span>' +
      '<span class="tb-price-now">' + formatMoney(discountedAmount(original, rate)) + '</span>';
  }

  function isGiftPriceText(text) {
    return /^Free$/i.test(String(text || '').replace(/\s+/g, ' ').trim());
  }

  function isGiftLine(el) {
    var item = el.closest('li');
    if (!item) return false;
    if (item.querySelector('.as-bab-product-base-total')) return true;
    if (isGiftPriceText(el.textContent)) return true;
    var now = el.querySelector('.tb-price-now');
    return !!(now && isGiftPriceText(now.textContent));
  }

  function getBoxTotalsFromWidget() {
    var itemCount = 0;
    var preDiscountSpend = 0;
    var cards = document.querySelectorAll('#AppstleBabMain [class*="product-id-"]');
    for (var i = 0; i < cards.length; i++) {
      var qty = getCardQuantity(cards[i]);
      if (qty < 1) continue;
      var priceEl = cards[i].querySelector('.as-bundle-product-final-price');
      itemCount += qty;
      preDiscountSpend += captureOriginal(priceEl) * qty;
    }
    var rate = getDiscountRate(itemCount, preDiscountSpend);
    return {
      itemCount: itemCount,
      preDiscountSpend: preDiscountSpend,
      discountedSpend: discountedAmount(preDiscountSpend, rate),
      rate: rate
    };
  }

  function totalsFromCart(cart) {
    var itemCount = 0;
    var preDiscountSpend = 0;
    var discountedSpend = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || !item.selling_plan_allocation) continue;
      itemCount += item.quantity || 0;
      preDiscountSpend += centsToDollars(item.original_line_price);
      discountedSpend += centsToDollars(item.final_line_price != null ? item.final_line_price : item.line_price);
    }
    return {
      itemCount: itemCount,
      preDiscountSpend: preDiscountSpend,
      discountedSpend: discountedSpend,
      rate: getDiscountRate(itemCount, preDiscountSpend)
    };
  }

  function refreshCartTotals() {
    if (cartRequestInFlight) return;
    cartRequestInFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        lastCartTotals = totalsFromCart(cart);
        if (!document.hidden) tick();
      })
      .catch(function () {})
      .then(function () {
        cartRequestInFlight = false;
      });
  }

  function getTotals() {
    var boxTotals = getBoxTotalsFromWidget();
    if (boxTotals.itemCount > 0) return boxTotals;
    if (lastCartTotals) return lastCartTotals;
    return boxTotals;
  }

  function updateSlashedPrices(totals) {
    var rate = totals.rate || 0;
    var cards = document.querySelectorAll('#AppstleBabMain [class*="product-id-"] .as-bundle-product-final-price');
    for (var i = 0; i < cards.length; i++) {
      paintPrice(cards[i], captureOriginal(cards[i]), rate);
    }

    var cartPrices = document.querySelectorAll('.as-bundle-cart-dailog .as-selected .as-discount.as-per-delivery');
    for (var j = 0; j < cartPrices.length; j++) {
      if (isGiftLine(cartPrices[j])) continue;
      paintPrice(cartPrices[j], captureOriginal(cartPrices[j]), rate);
    }

    var subtotal = document.querySelector('.as-bundle-cart-dailog .as-sub-total .transcy-money');
    if (subtotal) paintPrice(subtotal, totals.preDiscountSpend, rate);
  }

  function ensureBars(host, id) {
    if (!host) return null;
    var existing = host.querySelector('.tb-tier-bars');
    if (existing && existing.querySelector('.tb-fill-10')) return existing;
    if (existing) existing.remove();
    var wrapper = buildWrapper();
    wrapper.id = id;
    host.appendChild(wrapper);
    return wrapper;
  }

  function paintBars(wrapper, totals) {
    if (!wrapper) return;
    var itemCount = totals.itemCount;
    var preDiscountSpend = totals.preDiscountSpend;
    var pct10 = Math.min(100, (itemCount / ITEM_TARGET_10) * 100);
    var pct15 = Math.min(100, (itemCount / ITEM_TARGET_15) * 100);
    var pctShip = Math.min(100, (preDiscountSpend / SHIPPING_TARGET) * 100);
    var pct20 = Math.min(100, (preDiscountSpend / SPEND_TARGET) * 100);

    var fills = [
      { sel: '.tb-fill-10', pct: pct10, done: itemCount >= ITEM_TARGET_10 },
      { sel: '.tb-fill-15', pct: pct15, done: itemCount >= ITEM_TARGET_15 },
      { sel: '.tb-fill-ship', pct: pctShip, done: preDiscountSpend >= SHIPPING_TARGET },
      { sel: '.tb-fill-20', pct: pct20, done: preDiscountSpend >= SPEND_TARGET }
    ];
    for (var i = 0; i < fills.length; i++) {
      var fill = wrapper.querySelector(fills[i].sel);
      if (!fill) continue;
      fill.style.width = fills[i].pct + '%';
      fill.classList.toggle('tb-complete', fills[i].done);
    }

    var c10 = wrapper.querySelector('.tb-tier-count-10');
    var c15 = wrapper.querySelector('.tb-tier-count-15');
    var cShip = wrapper.querySelector('.tb-tier-count-ship');
    var c20 = wrapper.querySelector('.tb-tier-count-20');
    if (c10) c10.textContent = itemCount + ' / ' + ITEM_TARGET_10 + ' items';
    if (c15) c15.textContent = itemCount + ' / ' + ITEM_TARGET_15 + ' items';
    if (cShip) cShip.textContent = formatMoney(preDiscountSpend) + ' / ' + formatMoney(SHIPPING_TARGET);
    if (c20) c20.textContent = formatMoney(preDiscountSpend) + ' / ' + formatMoney(SPEND_TARGET);
  }

  function totalsKey(totals) {
    return [
      totals.itemCount,
      Number(totals.preDiscountSpend || 0).toFixed(2),
      Number(totals.discountedSpend || 0).toFixed(2),
      totals.rate || 0
    ].join('|');
  }

  function hostsNeedBars() {
    var main = document.getElementById('AppstleBabMain');
    if (!main) return true;
    var footer = main.querySelector('.as-fixed.as-bottom-0');
    if (!footer || !footer.querySelector('.tb-tier-bars .tb-fill-10')) return true;
    var cartProgress = document.querySelector('.as-bundle-cart-dailog .limit-progress');
    return !!(cartProgress && !cartProgress.querySelector('.tb-tier-bars .tb-fill-10'));
  }

  function pricesNeedPaint(rate) {
    if (!rate) return false;
    var cardPrice = document.querySelector('#AppstleBabMain [class*="product-id-"] .as-bundle-product-final-price');
    if (cardPrice && !cardPrice.querySelector('.tb-price-now') && !isGiftPriceText(cardPrice.textContent)) {
      return true;
    }
    var cartPrice = document.querySelector('.as-bundle-cart-dailog .as-selected .as-discount.as-per-delivery');
    return !!(cartPrice && !isGiftLine(cartPrice) && !cartPrice.querySelector('.tb-price-now'));
  }

  function paintNeeded(totals) {
    return totalsKey(totals) !== lastPaintKey || hostsNeedBars() || pricesNeedPaint(totals.rate || 0);
  }

  function setTickInterval(ms) {
    if (tickMs === ms && tickTimer) return;
    tickMs = ms;
    if (tickTimer) clearInterval(tickTimer);
    tickTimer = setInterval(tick, ms);
  }

  function startVisibleTimers() {
    setTickInterval(TICK_FAST_MS);
    if (!cartTimer) {
      cartTimer = setInterval(function () {
        if (!document.hidden) refreshCartTotals();
      }, CART_POLL_MS);
    }
  }

  function stopTimers() {
    if (tickTimer) clearInterval(tickTimer);
    tickTimer = null;
    tickMs = 0;
    if (cartTimer) clearInterval(cartTimer);
    cartTimer = null;
  }

  function wakeFast() {
    idleTicks = 0;
    if (!document.hidden) setTickInterval(TICK_FAST_MS);
    if (!document.hidden) tick();
  }

  function tick() {
    if (document.hidden) return;
    ensureStaticStyles();
    moveSubtitle();

    var totals = getTotals();
    if (!paintNeeded(totals)) {
      idleTicks += 1;
      if (idleTicks >= 3) setTickInterval(TICK_IDLE_MS);
      return;
    }

    lastPaintKey = totalsKey(totals);
    idleTicks = 0;
    updateSlashedPrices(totals);

    var footer = document.querySelector('#AppstleBabMain .as-fixed.as-bottom-0');
    if (footer) paintBars(ensureBars(footer, 'tb-tier-bars'), totals);

    var cartProgress = document.querySelector('.as-bundle-cart-dailog .limit-progress');
    if (cartProgress) paintBars(ensureBars(cartProgress, 'tb-tier-bars-cart'), totals);

    setTickInterval(TICK_FAST_MS);
  }

  function onCartEvent() {
    refreshCartTotals();
    wakeFast();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopTimers();
      return;
    }
    startVisibleTimers();
    refreshCartTotals();
    tick();
  });

  document.addEventListener('cart:refresh', onCartEvent);
  document.addEventListener('rebuy:cart.change', onCartEvent);
  document.addEventListener('rebuy:cart.ready', onCartEvent);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartEvent);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('#AppstleBabMain, .as-bundle-cart-dailog')) wakeFast();
  }, true);

  refreshCartTotals();
  if (!document.hidden) {
    startVisibleTimers();
    tick();
  }
})();
